import { Box, Stack, Text, IconEdit, Button, Badge } from '@machobear/design-system'
import capitalize from 'lodash/capitalize'
import { isEmpty } from 'lodash'
import { isEarlierThanCurrentMMYY } from '@/utils/check-expiry'
import { PaymentMethodType } from '@/components/ds-checkout-modal/types'
import {
  AmericanExpressCard,
  MastercardCard,
  PlaceholderCard,
  UnionPayCard,
  VisaCard
} from '@/components/icons'

const selectCardLogo = (type: string) => {
  switch (type?.toLowerCase()) {
    case 'visa':
      return <VisaCard />
    case 'amex':
      return <AmericanExpressCard />
    case 'mastercard':
      return <MastercardCard />
    case 'unionpay':
      return <UnionPayCard />
    default:
      return <PlaceholderCard />
  }
}

type Props = {
  paymentInfo: any[]
  onEdit: (index: number) => void
}

const SavedPayments = ({ paymentInfo, onEdit }: Props) => {
  if (isEmpty(paymentInfo)) return 'No payment method'

  return paymentInfo.map((data: PaymentMethodType, index: number) => {
    const { payment_method_id, brand, card_number, first_name, last_name, expiration_date } = data
    const showExpiredWarnings = isEarlierThanCurrentMMYY(expiration_date)

    return (
      <Box display="flex" key={payment_method_id} border="borderField" borderRadius="standard">
        <Box padding="xsmall" style={{ minWidth: 50 }}>
          {selectCardLogo(brand)}
        </Box>
        <Box padding="xsmall" style={{ minWidth: 90, flex: 1, paddingLeft: 0 }}>
          <Stack space="xsmall">
            <Box style={{ paddingTop: 2 }}>
              <Text
                size="small"
                weight="strong"
              >{`${capitalize(brand)} **** ${card_number?.slice(-4) ?? '????'}`}</Text>
              {showExpiredWarnings && (
                <Box paddingLeft="xsmall">
                  <Badge tone="critical"> Expired</Badge>
                </Box>
              )}
            </Box>
            <Box>
              <Text size="small" tone="secondary">{`${first_name} ${last_name}`}</Text>
            </Box>
            <Box>
              <Text size="small" tone="secondary">{`Expires ${expiration_date?.slice(
                0,
                2
              )}/${expiration_date?.slice(2)}`}</Text>
            </Box>
          </Stack>
        </Box>
        <Box padding="xsmall" alignItems="flexStart" style={{ minWidth: 40 }}>
          <Button
            variant="transparent"
            icon={<IconEdit />}
            size="small"
            onClick={() => onEdit(index)}
          >
            Edit
          </Button>
        </Box>
      </Box>
    )
  })
}

export default SavedPayments
